import { render } from "./Edit.vue?vue&type=template&id=13fac1e4&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=13fac1e4&lang=scss&scoped=true"

import exportComponent from "/var/www/kostyum-admin-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fac1e4"]])

export default __exports__